"use strict";
export function Transform(size) {
  if (typeof size === "string") {
    return size;
  }
  let byte = size;
  if (!byte) {
    return "0Byte";
  }
  if (byte > 1024 * 1024 * 1024 * 1024) {
    return `${(byte / 1024 / 1024 / 1024 / 1024).toFixed(2)}TB`;
  }
  if (byte > 1024 * 1024 * 1024) {
    return `${(byte / 1024 / 1024 / 1024).toFixed(2)}GB`;
  }
  if (byte > 1024 * 1024) {
    return `${(byte / 1024 / 1024).toFixed(2)}MB`;
  }
  if (byte > 1024) {
    return `${(byte / 1024).toFixed(2)}KB`;
  }
  return `${byte.toFixed(2)}B`;
}
